import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchCohortLogs = (cohortId: string, setLogs: Function, setLoaded: Function, language: string) => {
  setLoaded(false);

  ApiService.get(`cohorts/${cohortId}/logs`)
    .then((response) => setLogs(response.data.cohort_logs))
    .catch((error) => {
      console.error("Error fetching cohort logs:", error);
      alert(translate(language, "PAGES.COHORT.LOGS.ERRORS.FETCH_LOG"));
    })
    .finally(() => setLoaded(true));
};

export const fetchCohortLogsDetailed = (cohortId: string, setLogs: Function, setLoaded: Function, language: string) => {
  setLoaded(false);

  ApiService.get(`cohorts/${cohortId}/logs/detailed`)
    .then((response) => setLogs(response.data.cohort_logs))
    .catch((error) => {
      console.error("Error fetching cohort detailed logs:", error);
      alert(translate(language, "PAGES.COHORT.LOGS.ERRORS.FETCH_COHORT_DETAILED_LOGS"));
    })
    .finally(() => setLoaded(true));
};
